module.exports = __webpack_public_path__ + "static/media/delivery_truck_icon.bf947b6a.svg";